"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var isNull_1 = __importDefault(require("./isNull"));
var isUndef_1 = __importDefault(require("./isUndef"));
/**
 * @category validators
 * @module isFunc
 */
function isFunc(o) {
    return !(isNull_1.default(o) || isUndef_1.default(o)) && typeof o === 'function';
}
exports.default = isFunc;
